<template>
  <div>
    <div
      v-if="formData.fileList.length<limitNum"
      class="upload-container">
      <el-upload
        action
        list-type="picture"
        :on-change="handleChange"
        :auto-upload="false"
        :limit="limitNum"
        :multiple="isMultiple"
        :on-exceed="handleExceed"
        :file-list="formData.fileList"
        :drag="drag"
      >
        <div class="upload-card">
          <div
            class="add-icon"></div>
        </div>
      </el-upload>

      <el-dialog :visible.sync="dialogVisible">
        <img
          width="100%"
          :src="dialogImageUrl"
          alt="">
      </el-dialog>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="file-container">
        <ul class="el-upload-list el-upload-list--picture">

          <li
            v-for="(file, index) in formData.fileList"
            :key="index"
            tabindex="0"
            class="mg-b-10"
            @click="handleClickIndex(index)"
          >
            <div  class="el-upload-list__item ">
              <img
                :src="file.url"
                alt=""
                class="el-upload-list__item-thumbnail">
              <div :class="{'flex-cloumn':isHasType}">
                <a
                  class="el-upload-list__item-name pointer"
                  :class="{'mg-t-0 no-wrap':isHasType}"
                  @click="handlePictureCardPreview(file)">
                  <i class="el-icon-document"></i>
                  {{ file.name }}
                </a>
                <div
                  v-if="isHasType"
                >
                  <el-form-item
                    :ref="`fileList.${index}.select_type`"
                    :rules="rules.select"
                    :prop="`fileList.${index}.select_type`" >
                    <v-cascader
                      v-model="file.select_type"
                      :class-id-is-num="false"
                      :select-props="selectProps"
                      :list="uploadTypeList"
                      @change="handleChangeType"></v-cascader>
                  </el-form-item>
                </div>
              </div>
              <i
                class="el-icon-close"
                @click="handleRemove(index)"></i>
            </div>
          <!--          <v-select-list-->
          <!--            v-model="file.is_select"-->
          <!--            :list="categories"-->
          <!--            @select="handleSelectCategories"-->
          <!--          ></v-select-list>-->
          </li>
        </ul>
      </div>
    </el-form>
    <!--    <v-button-->
    <!--      class="mg-t-10"-->
    <!--      :disabled="fileList.length<=0"-->
    <!--      green-->
    <!--      @click="submitUpload">上傳到服務器</v-button>-->
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {ocrFileDetail} from '@api/ocr'
import axios from 'axios'
export default {
  mixins: [MixinOptions,MixinRules],
  props:{
    isMultiple: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    limitNum:{
      type:Number,
      default:10
    },
    isHasType:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formData:{
        fileList: [],
      },
      origin_file:[],
      dialogImageUrl: '',
      dialogVisible: false,
      selectProps:{
        value:'id',
        label:'name',
        children:'location',
        expandTrigger: 'hover'
      }
    }
  },
  computed:{
    disableList(){
      let {fileList=[]} = this.formData||{}
      let arr = fileList.reduce((res,item)=>{
        res.push({select_type:item.select_type})
        return res
      },[])
      return arr||[]
    },
    uploadTypeList() {
      return (this.uploadTypeOptions || []).map(item => {
        // 深拷贝当前项
        const newItem = { ...item, disabled: false }
        // 检查是否应该禁用父级（没有location且被选中）
        const shouldDisableParent = !item.location && this.disableList.some(
          path => path.select_type && path.select_type[0] === item.id
        )
        // 处理父级禁用状态
        if (shouldDisableParent) {
          newItem.disabled = true
        }
        // 处理location子项的禁用状态
        if (newItem.location) {
          newItem.location = newItem.location.map(loc => ({
            ...loc,
            disabled: this.disableList.some(
              path => path.select_type &&
                path.select_type[0] === item.id &&
                path.select_type[1] === loc.id
            )
          }))
        }

        return newItem
      })
    },
    selectName() {
      return file => {
        let name = this.getOptionName('categories', file.select_type)
        return name || 'Select'
      }
    },
  },
  watch: {},
  methods: {
    handleClickIndex(index){
      this.index = index
    },
    handleChangeType(data) {
      let arr = JSON.parse(JSON.stringify(this.formData.fileList))
      arr[this.index].is_select = false
      arr[this.index].type = data[0]
      arr[this.index].location = data.length>1?data[1]:0
      this.formData.fileList = arr
    },
    handleSelect(index) {
      this.index = index
      let arr = JSON.parse(JSON.stringify(this.formData.fileList))
      arr[index].is_select = !arr[index].is_select
      this.formData.fileList = arr
    },
    handleRemove(index) {
      let arr = JSON.parse(JSON.stringify(this.formData.fileList))
      arr.splice(index, 1)
      this.origin_file.splice(index,1)
      this.formData.fileList = arr
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleChange(file, fileList) {
      this.formData.fileList.push({
        ...file,
        is_select: false,
        type: '',       // 初始化类型
        location: '',   // 初始化位置
        select_type: '',
      })
      this.origin_file.push({...file})
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上傳 ${this.limitNum} 張圖片`)
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        let {fileList=[]} = this.formData||{}
        if(fileList.length<=0)
          return  resolve([])
        this.$refs['form'].validate(async (valid, rules) => {
          if(valid){
            let formData = new FormData() // 创建一个FormData对象
            fileList.forEach((file, index) => {
              formData.append(`files[${index}][type]`, file.type )
              formData.append(`files[${index}][location]`, file.location )
              formData.append(`files[${index}][file]`,this.origin_file[index].raw) // 使用原生 File
            })
            this.$emit('input',fileList)
            resolve(formData)
          }else
            this.scrollToValidDom(rules)
          reject()
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.upload-container {
  width: 600px;
  &>div{
    height: 100%;
  }
  /deep/.el-upload-dragger{
    border: 0;
    width: 600px;
    height: 130px;

  }
  /deep/.el-upload-list{
    display: none;
  }
  .upload-card{
    z-index: 0;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 600px;
    height: 130px;
    border: 1px dashed #91939a;
    border-radius: 4px;
    .add-icon {
      width: 100%;
      height: 100%;
      &::before {
        z-index: -1;
        position: absolute;
        content: "";
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 1px;
        background: #979797;
      }
      &::after {
        z-index: -1;
        position: absolute;
        content: "";
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 50px;
        background: #979797;
      }
      &.noBorder{
        border: none;
        height: 100%;
      }
    }
  }

}
.file-container{
  margin-top: 16px;
  .el-upload-list{
    display: flex;
    flex-wrap: wrap;
    li{
      width: calc(50% - 8px);
      margin: 4px;
      .no-wrap{
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .mg-t-0{
        margin-top: 0!important;
      }
      .flex-cloumn{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 70px;
      }
    }
  }
}
</style>